<div class="modal-header">
	<h4 class="modal-title fw-bold">
		<span jhiTranslate="study.import-entry-details.title"></span>
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
			(click)="dismiss()">
	</button>
</div>
<div *ngIf="isFileUploadMode">
	<div class="modal-body pt-3">
		<div class="mb-3 row">
			<div class="col">
				<span jhiTranslate="template.download.description"></span>&nbsp;<a href (click)="export($event)" jhiTranslate="template.download.here"></a>.
			</div>
		</div>
		<div class="mb-3 row">
			<div class="col-2"></div>
			<div class="col-md-8">
                <label for="fileUpload" class="mb-1">
                    <i class="fa fa-search"></i>&nbsp;
                    <span jhiTranslate="study.import-entry-details.file.input.description"></span>
                </label>

				<jhi-file-select id="fileUpload"
								 [acceptedFileTypes]="selectedFileType"
								 (fileSelected)="onFileChange($event)"
								 (fileCleared)="clearSelectedFile()">
				</jhi-file-select>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="dismiss()">
			<span jhiTranslate="cancel"></span>
		</button>
		<button (click)="next()" class="btn btn-primary ms-2" [disabled]="isLoading">
			<span *ngIf="isLoading" class="throbber throbber-btn"></span>
			<span jhiTranslate="next"></span>
		</button>
	</div>
</div>

<div *ngIf="!isFileUploadMode">
	<div class="modal-body pt-3">
		<h3 jhiTranslate="study.import-entry-details.variable.matches.header"></h3>
		<br/>
		<div>
			<div class="row">
				<div class="col">
					<div class="table-responsive">
						<table class="table table-striped table-bordered table-curved">
							<thead>
							<th jhiTranslate="study.import-entry-details.variable.matches.columns.name"></th>
							<th jhiTranslate="study.import-entry-details.variable.matches.columns.description"></th>
							<th jhiTranslate="study.import-entry-details.variable.matches.columns.status"></th>
							</thead>
							<tbody *ngIf="rows && rows.length else nodata">
							<tr *ngFor="let variable of rows | slice: (page-1) * pageSize : page * pageSize">
								<td *ngIf="variable.id">
									<a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
									   [queryParams]="{ variableId: variable.id }"
									   queryParamsHandling="merge">
										{{variable.alias || variable.name}}
									</a>
								</td>
								<td *ngIf="!variable.id">
									{{variable.name}}
								</td>
								<td>
									{{variable.description}}
								</td>
								<td *ngIf="variable.skip">
									<span class="fa fa-lg fa-exclamation-circle text-danger"></span>
								</td>
								<td *ngIf="!variable.skip && variable.id && variable.isAlreadyExisting">
									<span class="fa fa-lg fa-check-circle text-success"></span>
								</td>
								<td *ngIf="!variable.skip && variable.id && !variable.isAlreadyExisting">
									<span class="fa fa-lg fa-plus-circle text-info"></span>
								</td>
								<td *ngIf="!variable.skip && !variable.id">
									<span class="fa fa-lg fa-times-circle text-danger"></span>
								</td>
							</tr>
							</tbody>
						</table>
						<ng-template #nodata>
							<tbody>
							<tr>
								<td colspan="6" jhiTranslate="no.data"></td>
							</tr>
							</tbody>
						</ng-template>
					</div>
					<div>
						<p class="mb-1"><span class="fa fa-check-circle text-success"></span>&nbsp;<span jhiTranslate="study.import-entry-details.exist"> exist in study</span></p>
						<p class="mb-1"><span class="fa fa-plus-circle text-info"></span>&nbsp;<span jhiTranslate="study.import-entry-details.new"> new to study</span></p>
						<p class="mb-1"><span class="fa fa-times-circle text-danger"></span>&nbsp;<span jhiTranslate="study.import-entry-details.not.found"> not found in the ontology</span></p>
						<p class="mb-1"><span class="fa fa-exclamation-circle text-danger"></span>&nbsp;
							<span jhiTranslate="study.import-entry-details.skip"> skip import of system variable once experiment was already generated</span></p>
					</div>
					<div class="row">
						<div class="col">
							<div class="pagination-container">
								<div class="pagination-box pagination-box-left">
									<div>
										<jhi-item-count [page]="page" [total]="rows.length" [itemsPerPage]="pageSize"></jhi-item-count>
									</div>
								</div>
								<div class="pagination-box">
									<ngb-pagination [collectionSize]="rows.length" [(page)]="page" [pageSize]="pageSize" [disabled]="isLoading"
													[maxSize]="5" [rotate]="true" [boundaryLinks]="true"></ngb-pagination>
								</div>
								<div class="pagination-box pagination-box-right">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="back()">
			<span jhiTranslate="back"></span>
		</button>
		<button (click)="approveVariableMatches()" class="btn btn-primary ms-2" [disabled]="isLoading">
			<span *ngIf="isLoading" class="throbber throbber-btn"></span>
			<span jhiTranslate="next"></span>
		</button>
	</div>
</div>
